import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
const isV3 = allVue.version && allVue.version[0] === '3'
import KendoToolBarMixin from './KendoToolBarMixin'

export default {
    name: 'kendo-toolbar',
    mixins: [ KendoToolBarMixin ],
    setup() {
        const v3 = isV3
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('div', defaultSlot)
    },
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoToolBar/index.js